import React, { useMemo } from "react";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
// import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
import { UserNotificationsDropdown } from "../extras/dropdowns/UserNotificationsDropdown";
// import { QuickActionsDropdown } from "../extras/dropdowns/QuickActionsDropdown";
// import { MyCartDropdown } from "../extras/dropdowns/MyCartDropdown";
// import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import ServiceApi from "../../../../core/services/service.api";
import { useNavigate } from "react-router-dom";
import moment from "moment-jalaali";

export function Topbar() {
  const navigate = useNavigate();
  function logout() {
    navigate("/logout");
  }
  moment.loadPersian({ usePersianDigits: false, dialect: "persian-modern" });

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(uiService.config, "extras.search.display"),
      viewNotificationsDisplay: objectPath.get(uiService.config, "extras.notifications.display"),
      viewQuickActionsDisplay: objectPath.get(uiService.config, "extras.quick-actions.display"),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(uiService.config, "extras.quick-panel.display"),
      viewLanguagesDisplay: objectPath.get(uiService.config, "extras.languages.display"),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  return (
    <div className="topbar align-items-center mt-1">
      {/* {layoutProps.viewSearchDisplay && <SearchDropdown />} */}

      {layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown />}

      {/* {layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />} */}

      {/* {layoutProps.viewCartDisplay && <MyCartDropdown />} */}

      {/* {layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )} */}

      {/* {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />} */}
      <a
        href="#"
        className="btn btn-light btn-sm font-weight-bold ms-3"
        id="kt_dashboard_daterangepicker"
        data-toggle="tooltip"
        title="Select dashboard daterange"
        data-placement="left"
      >
        {/* <span className="text-muted font-weight-bold mr-2" id="kt_dashboard_daterangepicker_title">Today</span> */}
        <span className="text-primary font-weight-bold" id="kt_dashboard_daterangepicker_date">
          {moment().format("dddd - jD jMMMM jYYYY")}
        </span>
      </a>
      <OverlayTrigger placement="bottom" overlay={<Tooltip id="quick-panel-tooltip">خروج از سیستم</Tooltip>}>
        <div
          className="topbar-item"
          data-toggle="tooltip"
          title="خروج از سیستم"
          data-placement="right"
          onClick={logout}
        >
          <div className="btn btn-icon btn-clean btn-lg mr-1" id="kt_quick_panel_toggle">
            <span className="svg-icon svg-icon-xl svg-icon-primary mt-1">
              <i className="fa fa-power-off"></i>
            </span>
          </div>
        </div>
      </OverlayTrigger>

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
